/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface DocumentForDisplay
 */
export interface DocumentForDisplay {
  /**
   *
   * @type {string}
   * @memberof DocumentForDisplay
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof DocumentForDisplay
   */
  displayName?: string
}

export function DocumentForDisplayFromJSON(json: any): DocumentForDisplay {
  return DocumentForDisplayFromJSONTyped(json, false)
}

export function DocumentForDisplayFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentForDisplay {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: !exists(json, 'id') ? undefined : json['id'],
    displayName: !exists(json, 'display_name') ? undefined : json['display_name']
  }
}

export function DocumentForDisplayToJSON(value?: DocumentForDisplay | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    display_name: value.displayName
  }
}
